module.exports = "input.search-input {\n  min-width: 450px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/brothers-attribution/brothers-attribution-page/leagcy-brother-attribution-main-child-search/legacy-brother-attribution-main-child-search.component.scss
// module id = ./src/app/admin/brothers-attribution/brothers-attribution-page/leagcy-brother-attribution-main-child-search/legacy-brother-attribution-main-child-search.component.scss
// module chunks = main